import { render, staticRenderFns } from "./NewsletterSignupComponent.vue?vue&type=template&id=2d4e0d9a&scoped=true&"
import script from "./NewsletterSignupComponent.vue?vue&type=script&lang=js&"
export * from "./NewsletterSignupComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterSignupComponent.vue?vue&type=style&index=0&id=2d4e0d9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e0d9a",
  null
  
)

export default component.exports